import axios from "axios";

const API = axios.create({ baseURL: "https://students--hub.herokuapp.com" });

export const getData = (subCode, chapterNo) =>
  API.get(`/getData/${subCode}/${chapterNo}`);

export const createData = (formData) => API.post(`/create`, formData);
